import { copyTextToClipboard } from "../utils/copy.ts";
import { useIntl } from "react-intl";
import ButtonWithTooltipFeedback from "./ButtonWithTooltipFeedback.tsx";
import { ComponentPropsWithoutRef, forwardRef, Ref } from "react";

interface CopyButtonWithFeedbackProps
  extends Omit<
    ComponentPropsWithoutRef<typeof ButtonWithTooltipFeedback>,
    "action"
  > {
  textToCopy: string;
}

function CopyButtonWithFeedback(
  { textToCopy, ...rest }: CopyButtonWithFeedbackProps,
  ref: Ref<HTMLButtonElement>
) {
  const intl = useIntl();

  return (
    <ButtonWithTooltipFeedback
      {...rest}
      ref={ref}
      action={() =>
        copyTextToClipboard(textToCopy)
          .then(() => intl.formatMessage({ defaultMessage: "Copied!" }))
          .catch(() => intl.formatMessage({ defaultMessage: "Failed to Copy" }))
      }
    />
  );
}

const ForwardRef = forwardRef(CopyButtonWithFeedback);
export default ForwardRef;
